module.exports = __webpack_public_path__ + "static/media/bos.18ae38db.svg";